import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import './style.css'

import logo from './assets/logo.svg'

const Footer = () => {
    return (
        <>
            <div className='copyright'>
                <Container>
                    <Row className="copyright__row">
                        <Col xs={12} sm={12} md={12} lg={6}>
                            <div className="copyright__wrapper-image">
                                <img className="copyright__image" src={logo} alt="logo soniteka" />
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={6} >
                            <p className="copyright__text">
                                Copyright © Soniteka. Sva prava zadržana.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default Footer
